import { type QueryObserverOptions, useQuery } from '@tanstack/react-query';

import FunctionKey from 'constants/functionKey';
import { useChainId, usePublicClient } from 'libs/wallet';
import type { PublicClient } from 'viem';
import {
  type GetBittensorNativeBalancesInput,
  type GetBittensorNativeBalancesOutput,
  getBittensorNativeBalances,
} from '.';

type TrimmedInput = Omit<GetBittensorNativeBalancesInput, 'publicClient' | 'chainId'>;

export type UseGetBittensorNativeBalancesQueryKey = [
  FunctionKey.GET_BITTENSOR_NATIVE_BALANCES,
  TrimmedInput & { chainId: GetBittensorNativeBalancesInput['chainId'] },
];

type Options = QueryObserverOptions<
  GetBittensorNativeBalancesOutput,
  Error,
  GetBittensorNativeBalancesOutput,
  GetBittensorNativeBalancesOutput,
  UseGetBittensorNativeBalancesQueryKey
>;

export const useGetBittensorNativeBalances = (input: TrimmedInput, options?: Partial<Options>) => {
  const { chainId } = useChainId();
  const { publicClient } = usePublicClient();

  return useQuery({
    queryKey: [FunctionKey.GET_BITTENSOR_NATIVE_BALANCES, { ...input, chainId }],
    queryFn: () =>
      getBittensorNativeBalances({
        ...input,
        chainId,
        publicClient: publicClient as PublicClient,
      }),
    enabled: !!input.accountAddress,
    ...options,
  });
};
